// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getServicesCommon } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetServicesCommonApi = createAsyncThunk("hitGetServicesCommonApi", async (serviceName) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        //Authorization: `${localStorage.getItem("clientToken")}`,
      },
      params: {
        serviceName,
      },
    };

    const url = ApiBaseUrl + getServicesCommon;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const GetServicesCommonSlice = createSlice({
  name: "getServicesCommonReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetServicesCommonData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetServicesCommonApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetServicesCommonApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetServicesCommonApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetServicesCommonData } = GetServicesCommonSlice.actions;
export default GetServicesCommonSlice.reducer;
